import { ApiClient } from "@mondaydotcomorg/api";

import { createItemMutation } from "./mutations/createItem.graphql";
import { createSubitemMutation } from "./mutations/createSubitem.graphql";
import { createUpdateMutation } from "./mutations/createUpdate";
import { deleteAllFilesMutation } from "./mutations/deleteAllFiles.graphql";
import { updateItemMutation } from "./mutations/updateItem.graphql";
import { uploadFileMutation } from "./mutations/uploadFile.graphql";
import { clientInfosQuery } from "./queries/clientInfos.graphql";
import { boardsFromClientWorkspaceQuery } from "./queries/getBoardsFromClientWorkspace.graphql";
import { statusChoicesQuery } from "./queries/getStatusChoices.graphql";
import { itemPageByValuesQuery } from "./queries/itemPageByValues.graphql";
import { itemsQuery } from "./queries/items.graphql";
import { itemsByPagesQuery } from "./queries/itemsByPages";
import { notificationsQuery } from "./queries/notifications";
import { operationDetailsQuery } from "./queries/operationDetails.graphql";
import { operationPlanningBaseQuery } from "./queries/operationPlanningBase";
import { operationsPageQuery } from "./queries/operations.graphql";
import { tasksCountQuery, tasksQuery } from "./queries/tasks.graphql";
import { updatesQuery } from "./queries/updates.graphql";
import { userInfoByEmailQuery } from "./queries/userByEmail.graphql";
import { boardWorkspaceIdQuery } from "./queries/workspaceId.graphql";

const _mondayClient = new ApiClient({
	token: process.env.MONDAY_API_TOKEN,
	requestConfig: {},
	apiVersion: "2025-10",
});

export const mondayClient = Object.assign(_mondayClient, {
	query: {
		tasks: tasksQuery,
		tasksCount: tasksCountQuery,
		clientInfos: clientInfosQuery,
		boardsFromClientWorkspace: boardsFromClientWorkspaceQuery,
		statusChoices: statusChoicesQuery,
		itemPageByValues: itemPageByValuesQuery,
		items: itemsQuery,
		updates: updatesQuery,
		operationDetails: operationDetailsQuery,
		userInfoByEmail: userInfoByEmailQuery,
		boardWorkspaceId: boardWorkspaceIdQuery,
		operationsPage: operationsPageQuery,
		operationPlanningBase: operationPlanningBaseQuery,
		itemsByPages: itemsByPagesQuery,
		notifications: notificationsQuery,
	},
	mutation: {
		createItem: createItemMutation,
		createSubitem: createSubitemMutation,
		updateItem: updateItemMutation,
		uploadFile: uploadFileMutation,
		createUpdate: createUpdateMutation,
		deleteAllFiles: deleteAllFilesMutation,
	},
});
